/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LockedClosedFolder(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LockedClosedFolder',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M0 11h6v4H0z","fill":"#E7BF3C"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M6 10c0-1.657-.377-4-3-4s-3 2.343-3 4h1c0-.788.096-1.583.4-2.151q.21-.4.544-.602C2.168 7.11 2.497 7 3 7s.832.11 1.056.247c.225.136.403.335.545.602C4.904 8.417 5 9.212 5 10z","fill":"#D6D6D6"}),createElement('path', {"d":"m6.26 3 1.28 1.368.594.632H13v4H9L7.125 7h-.678c.384.813.553 1.836.553 3v3h8V3H9L7.125 1H2v4.092A5 5 0 0 1 3 5q.54 0 1 .092V3z","fill":"currentColor"}))
}
